const notAllowedStatus = [
    'DELETED',
    'DRAFT',
    'PENDING',
    'REJECTED',
    'SENT BACK'
  ];

export {notAllowedStatus};